import { generateUuid } from '../../../helpers/string';
import { BlockType } from '../../Block/Block';
import { transformToDefaultBlock } from '../../Block/BlockTransformers';
import { transformToImage, transformToVideoWithFormats } from '../../Media/MediaTransformers';
import { MediaBannerInterface, MediaBannerResource } from './MediaBanner';

export const transformToMediaBanner = (resource: MediaBannerResource): MediaBannerInterface => {
    const defaultBlock = transformToDefaultBlock(resource);

    const id = defaultBlock.id || generateUuid();

    const image = resource.media
        ? transformToImage(resource.media)
        : undefined;

    const video = resource.video?.length
        ? transformToVideoWithFormats(resource.video)
        : undefined;

    return {
        ...defaultBlock,
        type: BlockType.mediaBanner,
        title: resource.title,
        titleColor: resource.titleColor || '',
        subtitle: resource.subtitle || '',
        subtitleColor: resource.subtitleColor || '',
        link: resource.link || undefined,
        linkBackgroundColor: resource.linkBackgroundColor,
        media: {
            id,
            video,
            image,
        },
    };
};
